<template>
    <div class="product-item">
        <router-link :to="'/product/'+item.spuId+'/'+item.skuId" class="img-box">
            <img :src="item.imgUrl+'?x-oss-process=image/resize,m_pad,h_300,w_300,color_FFFFFF'" :alt="item.name">
        </router-link>
        <div class="item-info">
            <router-link :to="'/product/'+item.spuId+'/'+item.skuId" class="name">
                {{item.name}}
            </router-link>
            <div class="code">{{item.code}}</div>
            <div class="size">{{item.size}}</div>
        </div>
    </div>
</template>

<style lang="scss"  type="text/scss" scoped>
    $height:200px;
    .product-item{
        @include clearfix;
    }
    .img-box{
        float: left;
        display: inline-block;
        width:$height;
        height: $height;
        img{
            width: 100%;
            height: auto;
        }
    }
    .item-info{
        float: left;
        height: $height;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name{
            @include SourceHanSerifSC-bold;
            font-size: 16px;
            margin-bottom: 5px;
        }
        .code,.size{
            font-size: 11px;
            color: #B8B8B8;
        }
        .code{
            margin-bottom: 5px;
        }
    }
</style>

<script>
    export default {
        data() {
            return {}
        },
        props:{
            item:{
                type:Object,
                default(){
                   return {
                       name:'',
                       skuId:'',
                       imgUrl:'',
                       code:'',
                       size:''
                   }
                }
            }
        }
    }
</script>